import React, { useState, useEffect, useRef } from "react";
import { Col, Image, Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Axios from "axios";

//STYLES
import * as SlotStyles from "../styles/slot";

//IMAGES
import albumImage from "../Images/photoAlbumIcon.png";

function VideoSlot(props) {
    const navigate = useNavigate();

    const textRef = useRef(null);

    const [text, setText] = useState();
    const [textOverflow, setTextOverflow] = useState(false);

    const [over, setOver] = useState(false);

    const [modalYN, setModalYN] = useState({
        open: false,
        heading: "",
        message: "",
        acceptFunction: "",
        acceptName: "",
        showAccept: false,
        cancelName: "",
        showCancel: false
    });

    function handleModalYNClose() {
        setModalYN((prevState) => {
            return { ...prevState, open: false };
        });
    }

    useEffect(() => {
        setText(props.name);
    }, []);

    useEffect(() => {
        if (textRef != null) {
            if (textRef.current.scrollHeight > textRef.current.offsetHeight + 2) {
                setText(`${text.substring(0, 30)}...`);
                setTextOverflow(true);
            }
        }
        console.log("log");
    }, [text]);

    function handleMouseEnter() {
        setOver(true);
    }

    function handleMouseLeave() {
        setOver(false);
    }

    function handleDelete(videoUUID) {
        setModalYN({
            heading: "Delete Image",
            message: "Are you sure you want to delete this video?",
            showAccept: true,
            acceptName: "Yes",
            acceptFunction: acceptDeleteImage.bind(this, videoUUID),
            showCancel: true,
            cancelName: "No",
            open: true
        });
    }

    function acceptDeleteImage(videoUUID) {
        setModalYN((prevState) => {
            return { ...prevState, open: false };
        });

        const data = {
            videoSlotUUID: videoUUID
        };
        Axios.post("/pods/CPOD_PHOTOANDVIDEOGALLERY_ADMIN/deleteVideo", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    props.albumLoad();
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    function handleOpenMoveModal(currentAlbum, imageURL) {
        props.openMoveModal(currentAlbum, imageURL);
    }

    return (
        <div style={SlotStyles.videoBody} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <div style={over ? SlotStyles.imageCardTopShow : SlotStyles.imageCardTopHidden}>
                <Button onClick={handleOpenMoveModal.bind(this, props.album, props.videoUUID)}>
                    <i className="fa-solid fa-angle-right"></i>
                </Button>
                <Button onClick={handleDelete.bind(this, props.videoUUID)}>
                    <i className="fas fa-trash-alt"></i>
                </Button>
            </div>
            <div style={SlotStyles.cardPicture}>
                <div style={SlotStyles.cardPicture_firstSection}></div>
                <div style={SlotStyles.cardPicture_middleSection}>
                    <Image onClick={props.openVideoViewer} src={props.thumbnail} style={SlotStyles.albumImage} />
                </div>
                <div style={SlotStyles.cardPicture_lastSection}></div>
            </div>
            {textOverflow ? (
                <OverlayTrigger placement="bottom" overlay={<Tooltip>{props.name}</Tooltip>}>
                    <div ref={textRef} style={SlotStyles.cardText}>
                        {text}
                    </div>
                </OverlayTrigger>
            ) : (
                <div style={SlotStyles.cardText} ref={textRef}>
                    {text}
                </div>
            )}

            <Modal show={modalYN.open} onHide={handleModalYNClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalYN.heading}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalYN.message}</Modal.Body>
                <Modal.Footer>
                    {modalYN.showAccept ? (
                        <div>
                            <Button variant="primary" onClick={modalYN.acceptFunction}>
                                {modalYN.acceptName}
                            </Button>
                        </div>
                    ) : null}
                    {modalYN.showCancel ? (
                        <div>
                            <Button variant="primary" onClick={handleModalYNClose}>
                                {modalYN.cancelName}
                            </Button>
                        </div>
                    ) : null}
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default VideoSlot;
